<template>
  <div class="container bg_f9">
    <Header @input="input"></Header>
    <headerSearch></headerSearch>
    <div class="container pr">
      <div class="main w1440">
        <div class="pl20 lh26 fs14 mb10">
          <span class="col90">当前位置：</span><router-link class="point" to="/"><span class="col04">首页 /</span></router-link><span
              class="blue"> 消息</span>
        </div>
        <div class="flex">
          <div class="left_part">
            <div class="tablist point flex" v-for="(message, index) in messageList.activity_lists" :key="index"
              @click="testTabClick(index, message.type)" :class="tabIndex == index ? 'active' : 'unactive'">
              <div class=" mt5 mr15" :class="tabIndex == index ? 'active_icon_part' : 'icon_part'">
                <img class="icon" :src="message.icon" alt="">

              </div>
              <div class="flex-grow-1  ">
                <div class="flex-box mb10">
                  <div class="flex-grow-1 m-ellipsis fs16 col04 ">
                    {{ message.name }}
                  </div>
                  <div class="fs12 colc9c lh14" v-if="message.message">{{ message.message.createtime_text }}</div>
                </div>
                <div class="flex-box">
                  <div v-if="message.message" class="fs12  lh22 col90  m-ellipsis flex-grow-1">
                    {{ message.message.content }}</div>
                  <div v-if="message.total > 0" class="num_part colf tc fs12">{{ message.total }}</div>
                </div>
              </div>
            </div>
            <div class="tablist point flex" v-for="(message, index) in messageList.group_lists" :key="index"
              @click="testTabClick2(index, message.type)" :class="tabIndex2 == index ? 'active' : 'unactive'">
              <div class=" mt5 mr15" :class="tabIndex == index ? 'active_icon_part' : 'icon_part'">
                <img class="icon" :src="message.icon" alt="">
              </div>
              <div class="flex-grow-1  ">
                <div class="flex-box mb10">
                  <div class="flex-grow-1 m-ellipsis fs16 col04 ">
                    {{ message.name }}
                  </div>
                  <div class="fs12 colc9c lh14" v-if="message.message">{{ message.message.createtime_text }}</div>
                </div>
                <div class="flex-box">
                  <div v-if="message.message" class="fs12  lh22 col90  m-ellipsis flex-grow-1">
                    {{ message.message.content }}</div>
                  <div v-if="message.total > 0" class="num_part colf tc fs12">{{ message.total }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="tablist point flex" @click="clickCustomer" :class="showCustomer ? 'active' : 'unactive'">
              <div class=" mt5 mr20" style="padding-top: 7px;" :class="showCustomer ? 'active_icon_part' : 'icon_part'">
                <img class="icon" src="../../assets/static/icon/jxr_Message_icon5.png" alt="">
              </div>
              <div class="flex-grow-1  ">
                <div class="flex-box mb10">
                  <div class="flex-grow-1 m-ellipsis fs18 col04 lh28">
                    平台客服
                  </div>
                  <div class="fs14 colc9c lh14">9小时前</div>
                </div>
                <div class="flex-box">
                  <div class="fs16  lh22 col90  m-ellipsis flex-grow-1">
                    好的</div>
                  <div class="num_part colf tc fs14">9</div>
                </div>
              </div>
            </div> -->
          </div>
          <div v-if="!showCustomer" class="flex-grow-1 ml20 right_part right_part1">
            <template v-if="messageList2.length > 0">
              <template v-for="(item, index) in messageList2" :key="index">
                <div class="tc" @click="goMessage(item)">
                  <div class="time_part fs12 colf tc ">
                    {{ item.createtime_text }}
                  </div>
                </div>
                <div class="message_part1" @click="goMessage(item)">
                  <div class="border_b pb10 flex-box mb10">
                    <img class="icon mr10" src="../../assets/static/icon/jxr_Message_icon2.png" alt="">
                    <div class="flex-grow-1 fs14 col27 fwb lh26 m-ellipsis">{{ item.title }}</div>
                    <!-- <div class="fs16 col90 lh20 pr5 point">查看详情</div> -->
                    <img class="Message_arrow_right point " src="../../assets/static/icon/jxr_Message_arrow_right.png"
                      alt="">
                  </div>
                  <div class="fs14 col27  mb10 m-ellipsis" v-if="item.message_group == 'orders'">订单号：{{ item.extra.order_sn }}</div>
                  <div class="fs14 col27  mb10 m-ellipsis">{{ item.content }}</div>
                  <!-- <div class=" fs12 col96  ">{{ item.content }}</div> -->
                </div>
              </template>
              <!-- <div class="lh20 mb50 tc fs14 colc9c">- 以上为已读消息 -</div>
            <template v-for="(item, index) in 1" :key="index">
              <div class="tc">
                <div class="time_part fs14 colf tc ">
                  2024.06.17 17:35
                </div>
              </div>
              <div class="message_part1">
                <div class="border_b pb15 flex-box mb25">
                  <img class="icon mr15" src="../../assets/static/icon/jxr_Message_icon2.png" alt="">
                  <div class="flex-grow-1 fs18 col27 fwb lh26 m-ellipsis">资质到期提醒</div>
                  <div class="fs16 col90 lh20 pr5 point">查看详情</div>
                  <img class="Message_arrow_right point " src="../../assets/static/icon/jxr_Message_arrow_right.png"
                    alt="">
                </div>
                <div class="fs18 col27 lh26 mb10 m-ellipsis">您的**机构医药资质即将到期</div>
                <div class=" fs16 col96 lh22 m-ellipsis-l3">您的**机构医药资质即将到期，请尽快更新。</div>
              </div>
            </template> -->
            </template>
            <template v-else>
              <div  class="nodata fs16 tc">
                <img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                <div>暂无相关数据</div>
              </div>
            </template>
          </div>
          <div v-if="showCustomer" class="flex-grow-1 ml20 right_part right_part2 flex">
            <div class="box">
              <div id="content" class="content">
                <div v-for="(item, index) in info" :key="index">
                  <div class="info_r info_default" v-if="item.type == 'leftinfo'">
                    <div class="flex-box mb20">
                      <div class="circle circle_r mr15">
                        <img src="../../assets/static/icon/jxr_login_bj.png" class="pic_l" />
                      </div>
                      <div class="con_r con_text">
                        <div class="fs16 col27 lh26">{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="tc mtb25">
                      <div class="time_part fs14 colf tc ">
                        {{ item.time }}
                      </div>
                    </div>
                  </div>
                  <div class="info_l mb20" v-if="item.type == 'rightinfo'">
                    <div class="flex-box flex-end con_r con_text">
                      <div class="con_l fs16 colf lh26">{{ item.content }}</div>
                      <div class="circle circle_l">
                        <img src="../../assets/static/icon/jxr_login_logo.png" class="pic_l" />
                      </div>
                    </div>
                    <div class="tc">
                      <div class="time_part fs14 colf tc ">
                        {{ item.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="setproblem ptb20 pr30 pl40 flex">
                <textarea class="flex-grow-1" placeholder="请输入您想说的话…" id="text" v-model="customerText"
                  @keyup.enter="sentMsg()"></textarea>
                <button @click="sentMsg()" class="setproblems fs18 colf tc">
                  发 送
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderSearch from "../../components/headerSearch.vue";
import { useHead } from "@unhead/vue";
export default {
  name: "index",
  setup() {
    useHead({
      title: "消息-小狮优选",
      meta: [
        { name: "description", content: "This is my page description" },
        { property: "og:title", content: "My Page Title" },
        { property: "og:description", content: "This is my page description" },
        { property: "og:url", content: "https://example.com/my-page" },
        { property: "og:image", content: "https://example.com/my-image.jpg" },
      ],
      link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    });
  },
  components: {
    HeaderSearch,
  },
  data() {
    return {
      tablist: [
        {
          icon: require('../../assets/static/icon/jxr_Message_icon1.png'),
          name: '活动上新',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon1.png'),
          name: '活动上新',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon2.png'),
          name: '新开机构',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon2.png'),
          name: '资质到期提醒',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon3.png'),
          name: '订单状态',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon4.png'),
          name: '退单提醒',
        },
        {
          icon: require('../../assets/static/icon/jxr_Message_icon2.png'),
          name: '通知',
        },
        // {
        //   icon: require('../../assets/static/icon/jxr_Message_icon5.png'),
        //   name: '平台客服',
        // },
      ],
      customerText: "",
      info: [
      ],
      timer: null,
      //
      tabIndex: 0,
      tabIndex2: null,
      showCustomer: false,
      messageList: {
        activity_lists: [],
        group_lists: []
      },
      type: 'activity_new ',
      messageList2: [],
      messageMore: { page: 1 },
      deleteindex: 0,
      showdelete: false,
      refreshStatus: false,

    };
  },
  created() {
    if (this.$cookies.get("token")) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    let type = this.$route.query.type || 'activity_new';
    if(type){
      this.type = type;
    }
    this.showTimer();
    this.fetchSumary();
    this.fetchList();
  },
  methods: {
    // 获取左边消息列表
    fetchSumary() {
      let that = this;
      that.$api.GetMessage().then(res => {
        that.messageList = res.data;
        for (let i = 0; i < that.messageList.activity_lists.length; i++) {
          if(that.messageList.activity_lists[i].type == that.type){
            that.tabIndex2 = null;
            that.tabIndex = i;
            break;
          }
          
        }
         for (let j = 0; j < that.messageList.group_lists.length; j++) {
          if(that.messageList.group_lists[j].type == that.type){
            that.tabIndex2 = j;
            that.tabIndex = null;
            break;
          }
          
        }
        //that.fetchList();
      })

    },
    testTabClick(index, type) {
      this.tabIndex2 = null
      this.tabIndex = index
      this.showCustomer = false
      this.type = type
      this.fetchList()
    },
    testTabClick2(index, type) {
      this.tabIndex = null
      this.tabIndex2 = index
      this.showCustomer = false
      this.type = type
      this.fetchList()
    },
    // 获取右边消息列表
    fetchList() {
      let that = this;
      let query = { type: that.type };
      that.$api.GetMessagesList(query).then(res => {
        // that.messageList2 = that.messageList2.concat(res.data.data); //追加新数据
        that.messageList2 = res.data.data
        that.fetchSumary();
        that.$bus.emit("refreshMessage",{});
      })
    },
    goMessage(item){
				let url = '';
        let query = {};
				switch(item.message_group){
					case 'orders':
						url = '/OrderDetail'
            query = {orderSn: item.extra.order_sn}
						break;
					case 'aftersales':
						url = '/RefundStatus'
            query = {id: item.extra.aftersale_id};
						break;
					case 'activity_new':
						url = '/activities'
						break;
					case 'certificate':
						//url = '/pages/InstitutionDetails/InstitutionDetails'
					case 'institution_new':
						url = '/BaseInfo'
						break;
					case 'goods_new':
						url = '/FindProduct'
						break;
				}
				if(url){
					let routeUrl = this.$router.resolve({ path: url ,query: query});
					window.open(routeUrl.href, "_blank");
				}
			},
    clickCustomer() {
      this.showCustomer = !this.showCustomer
      this.tabIndex = null
      this.tabIndex2 = null
    },
    // 用户发送消息
    sentMsg() {
      clearTimeout(this.timer);
      this.showTimer();
      let text = this.customerText.trim();
      if (text != "") {
        var obj = {
          type: "rightinfo",
          time: this.getTodayTime(),
          content: text,
        };
        this.info.push(obj);
        // this.appendRobotMsg(this.customerText);
        this.customerText = "";
        this.$nextTick(() => {
          var contentHeight = document.getElementById("content");
          contentHeight.scrollTop = contentHeight.scrollHeight;
        });
      }
    },
    sentMsgById(val, id) {
      clearTimeout(this.timer);
      this.showTimer();

      let robotById = this.robotAnswer.filter((item) => {
        return item.id == id;
      });
      let obj_l = {
        type: "leftinfo",
        time: this.getTodayTime(),
        name: "robot",
        content: robotById[0].content,
        question: [],
      };
      let obj_r = {
        type: "rightinfo",
        time: this.getTodayTime(),
        name: "robot",
        content: val,
        question: [],
      };
      this.info.push(obj_r);
      this.info.push(obj_l);
      this.$nextTick(() => {
        var contentHeight = document.getElementById("content");
        contentHeight.scrollTop = contentHeight.scrollHeight;
      });
    },
    // 点击机器人的单个问题
    clickRobot(val, id) {
      this.sentMsgById(val, id);
    },
    // 结束语
    endMsg() {
      // let happyEnding = {
      //   type: "leftinfo",
      //   time: this.getTodayTime(),
      //   content: "",
      //   question: [],
      // };
      // this.info.push(happyEnding);
      this.$nextTick(() => {
        var contentHeight = document.getElementById("content");
        contentHeight.scrollTop = contentHeight.scrollHeight;
      });

    },
    showTimer() {
      this.timer = setTimeout(this.endMsg, 1000 * 60);
    },
    getTodayTime() {
      // 获取当前时间
      var day = new Date();
      let seconds = day.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds;
      } else {
        seconds = seconds;
      }
      let minutes = day.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      } else {
        minutes = minutes;
      }
      let time =
        day.getFullYear() +
        "-" +
        (day.getMonth() + 1) +
        "-" +
        day.getDate() +
        " " +
        day.getHours() +
        ":" +
        minutes +
        ":" +
        seconds;
      return time;
    },

  },
};
</script>
<style lang="less" scoped>
.cold7d {
  color: #D7D4D4;
}

.col36 {
  color: #363636;
}

.point {
  cursor: pointer;
}

.bg_f9 {
  background: #f9f9f9;
}

.col-36 {
  color: #363636;
}

.fw-600 {
  font-weight: 700;
}

.main {
  margin: 0 auto 35px;
  background: #f9f9f9;
}

.mt65 {
  margin-top: 65px;
}

.pl50 {
  padding-left: 50rpx;
}

.ml50 {
  margin-left: 50px;
}

.mr8 {
  margin-right: 8px;
}

.ml8 {
  margin-left: 8px;
}

.cold3 {
  color: #d3d3d3;
}

.main {
  margin: 0 auto 35px;
}

.col90 {
  color: #909090;
}

.col04 {
  color: #040404;
}

.blue {
  color: #3D7EFE;
}

.left_part,
.right_part {
  height: 590px;
  overflow-y: scroll;
}

.left_part {
  width: 300px;
}

.tablist {
  padding: 14px 30px;
}

.tablist .icon_part,
.active_icon_part {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
}

.tablist .icon_part .icon,
.active_icon_part .icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  object-fit: contain;
  margin: 0 auto;
}

.active_icon_part {
  background: #FFFFFF;
}

.icon_part:hover {
  background: #FFFFFF;
}

.Message_top {
  width: 14px;
  height: 14px;
  display: block;
  object-fit: contain;
  margin-bottom: 8px;
}

.colc9c {
  color: #C9CDD4;
}

.num_part {
  padding: 0 3px;
  min-width: 14px;
  height: 14px;
  line-height: 14px;
  border-radius: 999px;
  overflow: hidden;
  background: linear-gradient(153deg, #FF4D4D 0%, #FF652D 100%);
  box-shadow: 0px 0px 3px 0px rgba(218, 167, 167, 0.5);
}

.active,
.tablist:hover {
  background: #F4F5F7;
}

.unactive {
  background: #FFFFFF;
}

.right_part {
  background: #F4F5F7;
}

.right_part1 {
  padding:  14px 35px;
}

.time_part {
  display: inline-block;
  min-width: 178px;
  padding: 0 20px;
  height: 21px;
  line-height: 21px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 44px;
  margin-bottom: 18px;
}

.message_part1 {
  // width: 748px;
  padding: 14px 18px;
  background: #FFFFFF;
  border-radius: 0px 14px 14px 14px;
  margin-bottom: 20px;
}

.message_part1 .icon {
  width: 15px;
}

.message_part1:last-of-type {
  margin-bottom: 0;
}

.border_b {
  border-bottom: 1px solid rgba(98, 134, 171, 0.20);
}

.col27 {
  color: #272727;
}

.Message_arrow_right {
  widows: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
}

.col96 {
  color: #969696;
}

.right_part2 {
  padding: 14px 35px;
}

// kefu
.box {
  width: 100%;
}

#content {
  height: 700px !important;
  overflow-y: scroll;
}

.info_r {
  position: relative;
}

.info_r .pic_r {
  width: 17px;
  height: 17px;
  margin: 8px;
}

.info_r .con_r {
  display: inline-block;
  min-width: 86px;
  max-width: 400px;
  background-color: #fff;
  border-radius: 0px 14px 14px 14px;
  padding: 10px 20px;
}

.con_l {
  display: inline-block;
  min-width: 86px;
  max-width: 400px;
  background: #3D7EFE;
  border-radius: 14px 0px 14px 14px;
  padding: 10px 20px;
  text-align: left;
  color: #fff;
  margin-right: 15px;
}

.info_r .time_r {
  margin-left: 45px;
  color: #999999;
  font-size: 14px;
}

.info_l {
  text-align: right; // margin-right: 20px;
  color: #ffffff;
  color: #3163C5;
  margin-top: 10px;
}

.pic_l {
  width: 67px;
  height: 67px;
  display: block;
  object-fit: cover;
  margin: 0px auto;
  border-radius: 50%;
  overflow: hidden;
}

.time_l {
  margin-right: 45px;
  color: #999999;
  font-size: 14px;
  margin-top: 5px;
}

.circle {
  display: inline-block;
  width: 67px;
  height: 67px;
  border-radius: 50%;
  background-color: #eff1f3;
}

#question {
  cursor: pointer;
}

.setproblem {
  width: 100%;
  height: 160px;
  background-color: #ffffff;
  position: relative;
  border-radius: 8px;
}

.setproblem textarea {
  resize: none;
  border: none;
  font-size: 18px;
  height: 100%;
  color: #999999;
  box-sizing: border-box;
}

.setproblem textarea::placeholder {
  color: #909090;
}

.setproblem button {
  width: 88px !important;
  text-align: center;
  height: 42px !important;
  line-height: 42px !important;
  background: #1275FF;
  border-radius: 6px;
}
</style>
